module.exports = __webpack_public_path__ + "assets/img/warrior-name-a249518c.png";